var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#5EB5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.254 21.0066C25.2876 20.8562 22.8513 23.2925 23.0017 26.2588C23.13 28.7981 25.1937 30.8619 27.734 30.9911C30.7004 31.1415 33.1367 28.7052 32.9862 25.7389C32.857 23.1996 30.7932 21.1359 28.254 21.0076V21.0066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5078 34.3467H23.4805V61.8154H32.5078V34.3467Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9587 33.6997C50.4855 33.6997 48.0452 35.3566 46.3389 37.4728V34.3469H37.3115V61.8156H46.3389V45.7197C46.5832 42.2616 49.0518 41.359 50.8035 41.359C52.6482 41.359 54.9775 42.2566 54.9775 47.3038V61.8146H64.0048V42.4666C64.0048 42.4666 63.5999 33.6987 53.9587 33.6987V33.6997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a19728661e549807cd02ea9ca057864f.svg";
export { ForwardRef as ReactComponent };